import React, { useEffect, useState } from 'react';
import Rest from '../../../Server/Rest';
import config from '../../../settings/config';
import { STATUS_REQUEST } from '../../../constants/statuses';

const PercentageDelinquency = () => {
  const [percentage, setPercentage] = useState(0);
  const [saveStatus, setSaveStatus] = useState<string | null>(null);

  useEffect(() => {
    getCurrentPercentage();
  }, []);

  const getCurrentPercentage = () => {
    const config = JSON.parse(localStorage.getItem('Config') as string);
    if (config.percentageDelinquency) {
      setPercentage(config.percentageDelinquency);
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    setSaveStatus(STATUS_REQUEST.PENDING);

    const newValue = parseInt(event.target[0].value);

    Rest.peticion(`${config.api_url}/classes/SistemaPorcentajeMorosidad`, {
      method: 'POST',
      body: JSON.stringify({
        porcentaje: newValue,
        periodo: 'mensual',
        activo: true,
      }),
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setSaveStatus(STATUS_REQUEST.SUCCESS);
          const config = JSON.parse(localStorage.getItem('Config') as string);
          localStorage.setItem(
            'Config',
            JSON.stringify({
              ...config,
              percentageDelinquency: newValue,
            })
          );
        } else {
          setSaveStatus(STATUS_REQUEST.ERROR);
        }
      })
      .catch((error) => {
        console.error('Error al guardar el porcentaje de morosidad:', error);
        setSaveStatus(STATUS_REQUEST.ERROR);
        alert(
          'Ocurrió un error al intentar guardar el porcentaje de morosidad'
        );
      })
      .finally(() => {
        setTimeout(() => {
          setSaveStatus(null);
        }, 3000);
      });
  };

  const handleOnChange = (event: any) => {
    setPercentage(event.target.value);
  };

  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <label className="form-label">Porcentaje de Morosidad</label>
      <div className="input-group mb-3">
        <input
          type="number"
          className="form-control"
          placeholder="Porcentaje de morosidad"
          min={1}
          max={10}
          required
          onChange={handleOnChange}
          value={percentage}
        />
        <div className="input-group-append">
          <span className="input-group-text" id="basic-addon2">
            <i className="fas fa-percent"></i>
          </span>
        </div>
      </div>

      <button type="submit" className="btn btn-primary">
        Guardar
      </button>

      <div
        className={`valid-feedback ${
          saveStatus === STATUS_REQUEST.SUCCESS ? 'd-block' : ''
        }`}
      >
        Porcentaje guardado correctamente
      </div>

      <div
        className={`invalid-feedback ${
          saveStatus === STATUS_REQUEST.ERROR ? 'd-block' : ''
        }`}
      >
        El porcentaje no se pudo guardar
      </div>
    </form>
  );
};

export default PercentageDelinquency;
